import request from "@/utils/request";
import dayjs from "dayjs";

// 获取卸料排队列表
export function getList(params) {
  const {
    page: current,
    limit: size,
    date,
    sort,
    sortProp,
    ...otherWhere
  } = params;
  const whereKey = "urq";
  const payload = {
    page: {
      current,
      size,
    },
    where: Object.entries(otherWhere).reduce(
      (where, [name, value]) => (
        (where[`lk_${whereKey}.${name}`] = value), where
      ),
      {}
    ),
  };
  if (date && Array.isArray(date) && date.length) {
    payload.where = {
      [`ge_${whereKey}.createTime`]: dayjs(date[0])
        .startOf("day")
        .format("YYYY-MM-DD HH:mm:ss"),
      [`le_${whereKey}.createTime`]: dayjs(date[1])
        .endOf("day")
        .format("YYYY-MM-DD HH:mm:ss"),
    };
  }
  if (sort) {
    let value = "";
    if (sort === "ascending") value += `asc_${whereKey}.`;
    if (sort === "descending") value += `desc_${whereKey}.`;
    if (value) {
      value += sortProp;
      payload.where[value] = 1;
    }
  } else {
    payload.where[`asc_${whereKey}.createTime`] = "1";
  }
  return request.post("/unloading/list", payload);
}

export function add(data) {
  return request.post("/unloading/save", data);
}

export function del(data) {
  return request.get("/unloading/deleteById/" + data.id);
}
